/**
 * @generated SignedSource<<fbb315be2dc90e2d916a20088ae90c0c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateInvitationPayload",
    "kind": "LinkedField",
    "name": "createInvitation",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "InvitationEdge",
        "kind": "LinkedField",
        "name": "invitationEdge",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Invitation",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "kind",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "url",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "token",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateInvitationMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreateInvitationMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "cc2bafa99158e16ea91c325cb79d6b26",
    "id": null,
    "metadata": {},
    "name": "CreateInvitationMutation",
    "operationKind": "mutation",
    "text": "mutation CreateInvitationMutation(\n  $input: CreateInvitationInput!\n) {\n  createInvitation(input: $input) {\n    invitationEdge {\n      node {\n        id\n        kind\n        url\n        token\n      }\n    }\n  }\n}\n"
  }
};
})();

node.hash = "a48f213f34c23c3b5a01e32292555ca2";

export default node;
